import type { ShipmentFormStopRow } from '@/stores/useShipmentFormStore';
import { computeStopsRouteFingerprint } from '@/utils/compute-stops-route-fingerprint';

/**
 * True when stop routing coordinates changed but the hydrated route plan fingerprint
 * has not been refreshed yet (auto-route still pending or failed).
 */
export function haveStopsRoutePlanStale(
  stops: ShipmentFormStopRow[],
  serverHydratedRouteFingerprint: string | null,
): boolean {
  const fingerprint = computeStopsRouteFingerprint(stops);
  if (fingerprint == null) return true;
  if (serverHydratedRouteFingerprint == null) return true;
  return fingerprint !== serverHydratedRouteFingerprint;
}
